export const Translations = {
  ariaLabelNamespace: 'AriaLabels',
  ariaLabelKey: 'LanguageSelector_AriaLabel_TopLevel',
  ariaLabelDefault: 'Language Selector: {{language}}',
};

export const testIds = {
  languageSelectorContainer: 'language-selector-container',
  container: 'languages-container',
  dropdownHandle: 'languages-dropdown-handle',
  dropdownHandleContainer: 'languages-dropdown-handle-container',
  dropdownOptionText: 'languages-dropdown-option-text',
};
